import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { IPromotionsSummary } from 'core';
import { KorviuLoaderComponent } from 'shared';

@Component({
  selector: 'app-promotions-summary',
  imports: [DecimalPipe, KorviuLoaderComponent, TranslatePipe],
  templateUrl: './promotions-summary.component.html',
  styleUrl: './promotions-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PromotionsSummaryComponent {
  readonly summary = input<IPromotionsSummary | null>(null);
  readonly isLoading = input<boolean>(false);
  readonly cards = computed(() => [
    { key: 'availableTickets', icon: 'summary-tickets.svg', value: this.summary()?.available_tickets ?? 0 },
    { key: 'earnedGanas', icon: 'summary-ganas.svg', value: this.summary()?.earned_ganas ?? 0 },
    { key: 'eligiblePromotions', icon: 'summary-eligible.svg', value: this.summary()?.eligible_promotions ?? 0 }
  ]);
}
